import {Survey} from "../domain/survey";
import {WorksDone} from "../domain/worksDone";
import bingoRenoModel from "./bingo-reno-model.json";
import {Built} from "../domain/built";
import {AtticAmenagment} from "../domain/atticAmenagment";
import {BingoRenoAdvise} from "../domain/bingoRenoAdvise";

function builtOnModel(built: any) {
    switch (built) {
    case Built.Before1945:
       return "Avant 80";

    case Built.Between1945and1980:
       return "Avant 80";

    case Built.Between1980and2000:
       return "80 - 2000";

    case Built.After2000:
       return "Apres 2000";

    default:
        throw Error('unknown built')
    }
}

function atticOnModel(atticAmenagment: AtticAmenagment) {
    switch (atticAmenagment) {
        case AtticAmenagment.Converted:
             return "Rampants";
        case AtticAmenagment.NotConverted:
             return "Combles";
        default:
            throw new Error("unknown attic");
    }

}

export function createAdvise(survey: Survey) {
    console.log('Inputs', survey);

    let newWorksDone = [];

    if (survey.worksDone.includes(WorksDone.RoofIsolation)) {
        newWorksDone.push(WorksDone.RoofIsolation);
    } else {
        newWorksDone.push('');
    }

    if (survey.worksDone.includes(WorksDone.WindowIsolation)) {
        newWorksDone.push(WorksDone.WindowIsolation);
    } else {
        newWorksDone.push('');
    }

    if (survey.worksDone.includes(WorksDone.WallInternalIsolation)) {
        newWorksDone.push(WorksDone.WallInternalIsolation);
    } else {
        newWorksDone.push('');
    }

    if (survey.worksDone.includes(WorksDone.FloorIsolation)) {
        newWorksDone.push(WorksDone.FloorIsolation);
    } else {
        newWorksDone.push('');
    }

    if (survey.worksDone.includes(WorksDone.CentralHeatingChange)) {
        newWorksDone.push(WorksDone.CentralHeatingChange);
    } else {
        newWorksDone.push('');
    }

    if (survey.worksDone.includes(WorksDone.WoodBurnerChange)) {
        newWorksDone.push(WorksDone.WoodBurnerChange);
    } else {
        newWorksDone.push('');
    }

    // chauffe eau
    if (survey.worksDone.includes(WorksDone.ChauffeEau)) {
        newWorksDone.push(WorksDone.ChauffeEau);
    } else {
        newWorksDone.push('');
    }

    // panneaux solaire
    if (survey.worksDone.includes(WorksDone.PanneauSolaire)) {
        newWorksDone.push(WorksDone.PanneauSolaire);
    } else {
        newWorksDone.push('');
    }

    // vmc
    if (survey.worksDone.includes(WorksDone.InstallOrChangeVMC)) {
        newWorksDone.push(WorksDone.InstallOrChangeVMC);
    } else {
        newWorksDone.push('');
    }


    let binaryList = newWorksDone.map(work => work === '' ? 0 : 1);


    let binaryObject: Record<string, number> = binaryList.reduce((obj: Record<string, number>, value, index) => {
        obj[`__${index}`] = value;
        return obj;
    }, {} as Record<string, number>);

    let binaryObjectJson = JSON.stringify(binaryObject);

    console.log(binaryObjectJson);

    let matchingObjects: any[] = [];


    bingoRenoModel
        .filter((row:any) => row["QUESTIONS POSEES"] === builtOnModel(survey.built))
        .filter((row:any) => row["__9"] === atticOnModel(survey.atticAmenagment))
        .filter((row:any) => row["__13"] !== "#DIV/0!")
        .forEach((obj: any) => {
        let keys = Object.keys(binaryObject);
        if (keys.every((key, index) => {
            return obj.hasOwnProperty(key) && obj[key] === binaryObject[key];
        })) {
            matchingObjects.push(obj);
        }
    });

    return new BingoRenoAdvise(matchingObjects);
}